import { render } from "./MovieDetail.vue?vue&type=template&id=d1a70bb6&scoped=true"
import script from "./MovieDetail.vue?vue&type=script&lang=js"
export * from "./MovieDetail.vue?vue&type=script&lang=js"

import "./MovieDetail.vue?vue&type=style&index=0&id=d1a70bb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1a70bb6"]])

export default __exports__